import React from "react";
import { queryToObject } from "../../../libraries/helper";
import PaginationLayout from "react-js-pagination";

export default class Paginate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      perPage: 20,
    };
    this.handlePaginate = this.handlePaginate.bind(this);
  }
  handlePaginate(i) {
    this.setState({ page: i });
    this.props.history.push({
      pathname: this.props.match.path,
      search: "?" + new URLSearchParams({ page: i }).toString(),
    });
  }
  render() {
    return (
      <PaginationLayout
        innerclassName="pagination pagination-rounded"
        prevPageText="قبلی"
        firstPageText="اول"
        lastPageText="آخر"
        activeclassName="active"
        nextPageText="بعدی"
        itemclassName="page-item"
        linkclassName="page-link"
        totalItemsCount={this.props.totalRows}
        activePage={parseInt(this.state.page)}
        pageRangeDisplayed={5}
        itemsCountPerPage={this.state.perPage}
        onChange={this.handlePaginate}
      />
    );
  }

  componentDidMount() {
    if (this.props.location.search != "") {
      let params = queryToObject(this.props.location.search);
      this.setState({ page: params.page });
    }
  }
}
